import { render } from "./LetterPreviewModal.vue?vue&type=template&id=4a130c88"
import script from "./LetterPreviewModal.vue?vue&type=script&lang=js"
export * from "./LetterPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__